export default "__VITE_ASSET__Cg5yZti3__"